import { render, staticRenderFns } from "./EditMainSettingsModal.vue?vue&type=template&id=ca1a5924&scoped=true&"
import script from "./EditMainSettingsModal.vue?vue&type=script&lang=js&"
export * from "./EditMainSettingsModal.vue?vue&type=script&lang=js&"
import style0 from "./EditMainSettingsModal.vue?vue&type=style&index=0&id=ca1a5924&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca1a5924",
  null
  
)

export default component.exports